export default "/images/f3e42255e376562f9f872a55577c7c5d.avif";